
// * ========================================================================
// * Calc incidence rates
// * ========================================================================

import moment from 'moment';

const incidenceRates = (function(){

    function getTotalRateCount(data, dayIdx, rateDays) {
        let rate = null;

        const idxOld = dayIdx - rateDays + 1;
        if (typeof data.days[idxOld] !== 'undefined') {
            // Get rate
            let count = data.days[dayIdx].totalCount - data.days[idxOld].totalCount;
            rate = Math.round(((count / data.population) * 100000));
        }

        return rate;
    }

    function getAreaRateCount(data, area, areaIdx, dayIdx, rateDays) {
        let rate = null;

        const idxOld = dayIdx - rateDays + 1;
        if (typeof data.areaDays[idxOld] !== 'undefined') {
            // Get rate
            let count = data.areaDays[dayIdx].areas[areaIdx].totalCount - data.areaDays[idxOld].areas[areaIdx].totalCount;
            rate = Math.round(((count / area.population) * 100000));
        }

        return rate;
    }

    function needsUpdate(data, firstDate, rateString) {
        let update = false;
        if (!data || typeof data.rates === 'undefined' || typeof data.rates[rateString] === 'undefined' ||
            (data.rates[rateString] !== firstDate && data.rates[rateString] !== null && // existing date is not the same and existing date is not null
            (firstDate === null || firstDate < data.rates[rateString]))) { // new date is null or older than existing
            update = true;
        }

        return update;
    }

    function calculateRegionIncidenceRates(data, firstDate = null, rateDays = 14) {
        const rateString = 'rate_'+rateDays;

        if (needsUpdate(data, firstDate, rateString)) {
            for (let dayIdx = 0; dayIdx <= data.days.length - 1; dayIdx++) {
                if ((!firstDate || moment(data.days[dayIdx].date) >= firstDate) && typeof data.days[dayIdx][rateString] === 'undefined') {
                    // Day index for "all"
                    data.days[dayIdx][rateString] = getTotalRateCount(data, dayIdx, rateDays);

                    // Day index per area

                    for (let areaIdx = 0; areaIdx <= data.areaDays[dayIdx].areas.length - 1; areaIdx++) {
                        const area = data.areas[areaIdx];
                        data.areaDays[dayIdx].areas[areaIdx][rateString] = getAreaRateCount(data, area, areaIdx, dayIdx, rateDays);
                    }
                }
            }

            // Set main rates
            for (let idx = 0; idx <= data.areas.length - 1; idx++) {
                data.areas[idx][rateString] = typeof data.areaDays[data.areaDays.length - 2].areas[idx][rateString] !== 'undefined' ? data.areaDays[data.areaDays.length - 2].areas[idx][rateString] : data.areaDays[data.areaDays.length - 1].areas[idx][rateString];
            }

            // Save rate infos that have been done
            if (typeof data.rates === 'undefined') {
                data.rates = {};
            }
            data.rates[rateString] = firstDate;
        }
    }

    function getMunicipalityRateCount(municipality, dayIdx, rateDays = 14) {
        let rate = null,
            rateMax = null;

        const idxOld = dayIdx - rateDays + 1;

        if (typeof municipality.days[idxOld] !== 'undefined') {
            // Get min and max rate counts
            const countMax = municipality.days[dayIdx].count - municipality.days[idxOld].count;
            let countMin = municipality.days[dayIdx].count - municipality.days[idxOld].count;
            if (municipality.days[idxOld].count === 0) {
                // We cannot know if there was 0-4 existing before
                countMin = countMax - 4;
            }

            rate = Math.round(((countMin / municipality.population) * 100000));
            rateMax = Math.round(((countMax / municipality.population) * 100000));
        }

        return {
            rate,
            rateMax
        };
    }

    function calculateMunicipalityIncidenceRates(data, firstDate = null, rateDays = 14, municipalities) {
        const rateString = 'rate_'+rateDays;
        const rateStringMax = 'rateMax_'+rateDays;
        const calcAll = typeof municipalities === 'undefined';
        const dayObjects = {}; // So we do not need to create a new one every time

        for (let municipality of data.municipalities) {
            if (calcAll || (municipalities && municipalities.indexOf(municipality.id) !== -1)) {
                if (needsUpdate(municipality, firstDate, rateString)) {
                    for (let idx = 0; idx <= municipality.days.length - 1; idx++) {
                        if (typeof dayObjects[municipality.days[idx].date] === 'undefined') {
                            dayObjects[municipality.days[idx].date] = moment(municipality.days[idx].date);
                        }

                        if ((!firstDate || dayObjects[municipality.days[idx].date] >= firstDate) && typeof municipality.days[idx][rateString] === 'undefined') {
                            if (municipality.days[idx].count > 0) {
                                const { rate, rateMax } = getMunicipalityRateCount(municipality, idx, rateDays);

                                municipality.days[idx][rateString] = rate;
                                municipality.days[idx][rateStringMax] = rateMax;
                            } else {
                                municipality.days[idx][rateString] = 0;
                                municipality.days[idx][rateStringMax] = 0;
                            }

                            // Save main ones (last one)
                            if (idx === municipality.days.length - 1) {
                                municipality[rateString] = municipality.days[idx][rateString];
                                municipality[rateStringMax] = municipality.days[idx][rateStringMax];
                            }
                        }
                    }

                    // Save rate infos that have been done
                    if (typeof municipality.rates === 'undefined') {
                        municipality.rates = {};
                    }
                    municipality.rates[rateString] = firstDate;
                }
            }
        }
    }

    return {
        region: calculateRegionIncidenceRates,
        municipality: calculateMunicipalityIncidenceRates
    }

})();

export default incidenceRates;
